const IceBoxTypeList = () => import('Views/iceBoxType/iceBoxType-list');
const IceBoxTypeAddEdit = () => import('Views/iceBoxType/iceBoxType-addEdit');
const IceBoxTypeDetail = () => import('Views/iceBoxType/iceBoxType-detail');

export default[
  { path: '/iceBoxType-list', component: IceBoxTypeList },
  { path: '/iceBoxType-add', component: IceBoxTypeAddEdit },
  { path: '/iceBoxType-edit/:id', component: IceBoxTypeAddEdit },
  { path: '/iceBoxType-detail/:id', component: IceBoxTypeDetail },
];



// WEBPACK FOOTER //
// ./src/router/iceBoxType.js